import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { useSurveyContext } from "context/SurveyContext";
import { AnimatePresence, motion } from "framer-motion";
import SolveSurveyModal from "views/StudentSide/Survey/components/SolveSurveyModal";
import SurveyEnteranceModal from "views/StudentSide/Survey/components/SurveyEnteranceModal";

const SurveyModal = () => {
  const {
    showModal,
    selectedSurvey,
    isRequired,
    canRemindLater,
    closeSurveyModal,
    showSolveSurveyModal,
    showEnteranceModal,
    closeSolveSurveyModal,
    closeEnteranceModal,
    fetchAssignedSurveys
  } = useSurveyContext();

  const [loading, setLoading] = useState(false);
  const [surveyTags, setSurveyTags] = useState([]);

  const handleJoinNow = async () => {
    setLoading(true);
    closeSurveyModal(selectedSurvey, "start");
    setLoading(false);
  };

  const handleRemindLater = async () => {
    if (!selectedSurvey) return;
    setLoading(true);
    closeSurveyModal(selectedSurvey, "remind");
    setLoading(false);
  };

  const handleClose = () => {
    if (!isRequired || (isRequired && canRemindLater)) {
      closeSurveyModal();
    }
  };

  const handleSolveSurveyClose = () => {
    closeSolveSurveyModal();
    fetchAssignedSurveys();
  };

  const handleStartSurvey = (tags) => {
    setSurveyTags(tags || []);
    closeEnteranceModal(true);
  };

  const handleEnteranceClose = () => {
    closeEnteranceModal(false);
  };

  if (!showModal && !showEnteranceModal && !showSolveSurveyModal) {
    return null;
  }

  const canCloseModal = !isRequired || (isRequired && canRemindLater);

  return (
    <>
      <AnimatePresence mode="wait">
        {showModal && (
          <Modal
            show={showModal}
            onHide={canCloseModal ? handleClose : null}
            backdrop={canCloseModal ? true : "static"}
            keyboard={canCloseModal}
            centered
            size="md"
          >
            <motion.div
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -20 }}
              transition={{ duration: 0.2 }}
            >
              <Modal.Header>
                <Modal.Title>Anket</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="mb-4">
                  <h5 className="font-weight-bold">{selectedSurvey?.header || "Anket"}</h5>
                  {selectedSurvey?.description && (
                    <div
                      className="mt-2"
                      dangerouslySetInnerHTML={{ __html: selectedSurvey.description }}
                    />
                  )}
                </div>

                {isRequired && canRemindLater && (
                  <div className="alert alert-warning">
                    <strong>Önemli!</strong> Sistemi kullanmaya devam edebilmek için bu anketi{" "}
                    {selectedSurvey?.reminderDate
                      ? new Date(selectedSurvey.reminderDate).toLocaleDateString("tr-TR", {
                          day: "numeric",
                          month: "long",
                          year: "numeric"
                        }) + " tarihine kadar"
                      : ""}{" "}
                    tamamlamanız gerekiyor.
                  </div>
                )}

                {isRequired && !canRemindLater && (
                  <div className="alert alert-danger">
                    <strong>Dikkat!</strong> Anketin son hatırlatma tarihi geçti. Sistemi kullanmaya
                    devam etmek için bu anketi tamamlamanız gerekmektedir.
                  </div>
                )}
              </Modal.Body>
              <Modal.Footer>
                {canRemindLater && (
                  <Button
                    variant="outline-secondary"
                    onClick={handleRemindLater}
                    disabled={loading}
                  >
                    Daha Sonra Hatırlat
                  </Button>
                )}
                <Button variant="primary" onClick={handleJoinNow} disabled={loading}>
                  {canRemindLater ? "Ankete Katıl" : "Anketi Tamamla"}
                </Button>
              </Modal.Footer>
            </motion.div>
          </Modal>
        )}
      </AnimatePresence>

      {/* Okudum, Anladım modalı */}
      {showEnteranceModal && selectedSurvey && (
        <SurveyEnteranceModal
          show={showEnteranceModal}
          onHide={handleEnteranceClose}
          survey={selectedSurvey}
          startSurvey={handleStartSurvey}
        />
      )}

      {/* Anket çözme modalı */}
      {showSolveSurveyModal && selectedSurvey && (
        <SolveSurveyModal
          show={showSolveSurveyModal}
          onHide={handleSolveSurveyClose}
          selectedSurvey={selectedSurvey}
          preloadedTags={surveyTags}
        />
      )}
    </>
  );
};

export default SurveyModal;
